<template>
  <div class='home'>
    <ProductTypeList
      v-show='listView'
      @newProductType='onClickNewFromList'
      @editProductType='onClickEditFromList'
      :scroll="corY" ref='refreshList'
    />
    <ProductTypeForm
      v-show='formView'
      :productType='productType'
      @backClicked='onBackChild'
    />
  </div>
</template>

<script>
// @ is an alias to /src
import ProductTypeList from '@/components/product-type/ProductTypeList.vue'
import ProductTypeForm from '@/components/product-type/ProductTypeForm.vue'

export default {
  name: 'ProductType',
  components: {
    ProductTypeList,
    ProductTypeForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      productType: {
        id: null,
        name: null,
        accounts: [{
          id: null,
          account_code: null,
          description: null,
          type_id: null,
          company_no: null
        }]
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.productType = value
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.productType = {
        id: null,
        name: null,
        accounts: [{
          id: null,
          account_code: null,
          description: null,
          type_id: null,
          company_no: null
        }]
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.productType = {
        id: null,
        name: null,
        accounts: [{
          id: null,
          ptype_id: null,
          account_code: null,
          description: null,
          type_id: null,
          company_no: null
        }]
      }
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  },
  mounted () {
    this.$store.dispatch('getRowTable')
    this.$store.dispatch('getCompanyList')
    this.$store.dispatch('getAccountList')
    this.$store.dispatch('getProductAccountTypeLst')
  }
}
</script>
